{
  "name": "document-management",
  "version": "1.0.0",
  "author": "idok <idok@wix.com>",
  "description": "document-management",
  "license": "UNLICENSED",
  "private": true,
  "packageManager": "yarn@4.12.0",
  "onlineVersionAllocation": true,
  "experimentalMonorepoPublish": true,
  "workspaces": {
    "packages": [
      "[a-z]*"
    ]
  },
  "scripts": {
    "build": "yarn turbo build",
    "build:specs": "yarn petri-specs build",
    "clean": "lerna clean --yes && rm -rf ./node_modules",
    "clean:dist": "lerna run clean",
    "clean:dist-dir": "rm -rf */dist",
    "create-experiment": "yarn petri-specs new",
    "fix-proto-ci-issue": "chmod u+x conf/proto_ci_issue_fix.sh && sh conf/proto_ci_issue_fix.sh",
    "knip": "knip --config dependency-management/knip.ts",
    "lint": "yarn turbo lint",
    "lint-ts": "yarn lint && yarn ts",
    "rebuild": "yarn clean:dist-dir && yarn build:all",
    "start": "yarn start:tb",
    "start:bolt": "yarn workspace @wix/bolt-ds-adapter start",
    "start:tb": "yarn workspace @wix/tb-main start",
    "test": "lerna run test",
    "test:other-checks": "yarn validate-specs && syncpack list-mismatches && yarn check-experiments check",
    "test:sled:local": "yarn workspace sled-wrapper test:sled:local",
    "test:sled:local-debug": "yarn workspace sled-wrapper test:sled:local-debug",
    "ts": "tsc -b",
    "ts-rebuild": "tsc -b --clean && tsc -b",
    "validate-specs": "node conf/specs-names.mjs",
    "sign-fixer": "npx @digitak/esrun dm-cli/bin/create-fixer-signature-bin.js"
  },
  "publishConfig": {
    "registry": "https://npm.dev.wixpress.com/"
  },
  "repository": {
    "type": "git",
    "url": "git@github.com:wix-private/document-management.git"
  },
  "lint-staged": {
    "*.{js,ts}": [
      "eslint --cache"
    ],
    "yarn.lock": [
      "yarn dedupe --mode update-lockfile"
    ],
    "petri-specs/*.json": [
      "yarn validate-specs"
    ]
  },
  "devDependencies": {
    "@babel/cli": "^7.23.4",
    "@babel/core": "^7.23.7",
    "@babel/eslint-parser": "^7.23.3",
    "@babel/plugin-proposal-class-properties": "^7.18.6",
    "@babel/plugin-proposal-decorators": "^7.23.7",
    "@babel/plugin-proposal-export-default-from": "^7.23.3",
    "@babel/plugin-proposal-export-namespace-from": "^7.18.9",
    "@babel/plugin-proposal-nullish-coalescing-operator": "^7.18.6",
    "@babel/plugin-proposal-object-rest-spread": "^7.20.7",
    "@babel/plugin-proposal-optional-chaining": "^7.21.0",
    "@babel/plugin-transform-export-namespace-from": "^7.23.4",
    "@babel/plugin-transform-typescript": "^7.23.6",
    "@babel/preset-env": "^7.23.7",
    "@babel/preset-react": "^7.23.3",
    "@babel/register": "^7.23.7",
    "@babel/runtime": "^7.23.7",
    "@digitak/esrun": "^3.2.26",
    "@types/chance": "^1.1.6",
    "@types/fs-extra": "^11.0.4",
    "@types/jasmine": "^4.6.4",
    "@types/jest": "^29.5.11",
    "@types/js-yaml": "^4",
    "@types/lodash": "^4.14.202",
    "@types/node-fetch": "^2.6.10",
    "@types/prop-types": "^15.7.11",
    "@types/react": "^18.2.46",
    "@typescript-eslint/eslint-plugin": "^5.62.0",
    "@typescript-eslint/parser": "^5.62.0",
    "@wix/ambassador-data-science-ml-framework-v1-feature-vector": "^1.0.53",
    "@wix/babel-preset-yoshi": "^6.163.0",
    "@wix/ci-build-info": "^1.0.326",
    "@wix/eslint-plugin-santa": "^1.857.0",
    "@wix/jest-lambda-runner": "^1.0.143",
    "@wix/petri-lint": "^1.41.0",
    "@wix/santa-build": "^1.876.0",
    "@wix/santa-external-modules": "^1.644.0",
    "@wix/santa-utils": "^1.947.0",
    "@wix/sled-test-runner": "^2.0.481",
    "@wix/wix-santa": "^1.13803.0",
    "babel-jest": "^29.7.0",
    "babel-loader": "^9.1.3",
    "babel-plugin-transform-amd-to-commonjs": "^1.6.0",
    "chalk": "^5.3.0",
    "check-yarn-lock": "^0.2.1",
    "corvid-types": "^0.4.454",
    "detect-browser": "^5.3.0",
    "doctoc": "^2.2.1",
    "duplicate-package-checker-webpack-plugin": "^3.0.0",
    "eslint": "^8.56.0",
    "eslint-config-prettier": "^8.10.0",
    "eslint-config-wix-editor": "^8.4.2",
    "eslint-plugin-fp": "^2.3.0",
    "eslint-plugin-import": "^2.29.1",
    "eslint-plugin-jasmine": "^4.1.3",
    "eslint-plugin-jest": "^27.6.1",
    "eslint-plugin-prettier": "^4.2.1",
    "eslint-plugin-promise": "^6.1.1",
    "eslint-plugin-react": "^7.33.2",
    "eslint-teamcity": "^4.0.0",
    "esm": "^3.2.25",
    "execa": "^9.6.1",
    "fastdom": "^1.0.11",
    "fs-extra": "^11.2.0",
    "globby": "^13.2.2",
    "immutable": "^3.8.2",
    "is-ci": "^3.0.1",
    "istanbul": "^0.4.5",
    "jasmine": "^4.6.0",
    "jest": "^29.7.0",
    "jest-cli": "^29.7.0",
    "jest-config": "^29.7.0",
    "jest-leak-fixer": "^0.0.5",
    "jest-runtime": "^29.7.0",
    "js-beautify": "^1.14.11",
    "js-yaml": "^4.1.1",
    "knip": "^5.83.1",
    "lerna": "^6.6.2",
    "lint-staged": "^13.3.0",
    "node-fetch": "^2.7.0",
    "nodemon": "^2.0.22",
    "npm-run-all": "^4.1.5",
    "ora": "^6.3.1",
    "petri-specs": "^1.3.314",
    "prettier": "^2.8.8",
    "regenerator-runtime": "^0.14.1",
    "socket.io": "^2.5.0",
    "syncpack": "^9.8.6",
    "tap-teamcity": "^3.0.2",
    "terminate": "^2.6.1",
    "terser-webpack-plugin": "^5.3.10",
    "treeify": "^1.1.0",
    "ts-node": "^10.9.2",
    "tslib": "^2.6.2",
    "turbo": "^2.3.3",
    "typescript": "^5.4.5",
    "typescript-teamcity": "^1.1.0",
    "webpack": "^5.89.0",
    "webpack-bundle-analyzer": "^4.10.1",
    "webpack-cli": "^5.1.4",
    "webpack-dev-server": "^4.15.1"
  },
  "resolutions": {
    "@wix/editor-elements-types": "^1.3067.0",
    "pm-rpc": "3.2.7",
    "@types/lodash": "^4.14.202",
    "@wix/ambassador-editor-document-store": "^3.0.910",
    "@wix/ambassador-wix-meta-site-manager-webapp": "^2.0.1940",
    "@wix/blocks-widget-services": "^1.1432.0",
    "@wix/document-services-types": "^1.0.0",
    "@wix/viewer-manager-interface": "^1.0.0",
    "@wix/pro-gallery-wix-wrapper": "1.12.1561",
    "@wix/stylable-santa-flatten": "^2.0.358",
    "node-sass": "link:./.yarn/dummy-package",
    "carmi": "^1.0.333",
    "jest-environment-node": "^29.7.0",
    "jest-environment-jsdom": "^29.7.0",
    "jss": "^10.10.0",
    "wix-ui-core": "^3.0.234",
    "@wix/metro-runtime": "^1.2100.0",
    "@wix/metro-common-builders": "^1.0.1745"
  },
  "files": [
    "package.json",
    "dist/petri-experiments.json",
    "yarn.lock"
  ],
  "contributors": [
    {
      "name": "client-infra",
      "url": "https://github.com/orgs/wix-private/teams/client-infra/members"
    },
    {
      "name": "santa-infra-admins"
    },
    {
      "name": "santalittlehelper"
    },
    {
      "name": "yuvalnissan",
      "email": "yuvaln@wix.com"
    }
  ],
  "syncpack": {
    "dependencyTypes": [
      "dev",
      "prod"
    ]
  },
  "wix": {
    "loki": {
      "enable": false,
      "dedupe": true
    }
  }
}
